'use strict';exports.__esModule = true;var _lodash = require('lodash');
var _constants = require('../../constants');

var validate = function validate(values, _ref) {var isForeign = _ref.isForeign;
  var properties = values.propertyBlock || [];
  var errors = [];

  if (values.propertyBlock) {
    var membersArrayErrors = [];
    values.propertyBlock.forEach(function (property, index) {
      var propertiesErrors = {};

      if (!property || property.plan_images && !property.plan_images.length) {
        propertiesErrors.plan_images = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      if (!property || !property.start_price && !property.exact_price) {
        propertiesErrors.start_price = 'emptyField';
        propertiesErrors.exact_price = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      if (property.start_price && property.exact_price) {
        propertiesErrors.start_price = 'emptyField';
        propertiesErrors.exact_price = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      if (!property || !property.area) {
        propertiesErrors.area = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      if (!property || !property.property_type) {
        propertiesErrors.property_type = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      var name = (0, _lodash.get)(properties, index + '.name.' + (isForeign ? _constants.language.fallback : _constants.language.default));
      if (!property || !name) {
        propertiesErrors.name = {};
        propertiesErrors.name[isForeign ? _constants.language.fallback : _constants.language.default] = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }

      var summary = (0, _lodash.get)(properties, index + '.summary.' + (isForeign ? _constants.language.fallback : _constants.language.default));
      if (!property || !summary) {
        propertiesErrors.summary = {};
        propertiesErrors.summary[isForeign ? _constants.language.fallback : _constants.language.default] = 'emptyField';
        membersArrayErrors[index] = propertiesErrors;
      }
    });

    if (membersArrayErrors.length) {
      errors.propertyBlock = membersArrayErrors;
    }
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddPropertiesToProjectForm/validate.js
// module id = 2942
// module chunks = 0